import React from 'react';

const TextAbout = () => {
    return (
        <section className="highlight_banner bg-dark-200">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-11 p-lg-0">
                        <p className="about_para text-center">we meet new people <span><a href="#">everyday</a></span> coming with <span><a href="#">new dreams & hope our effort is to make them true</a></span></p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TextAbout;